module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"review_policy":"Review policy"}}')
  delete Component.options._Ctor
}
